"use strict";

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.string.bold");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.gradient = exports.hexa = exports.boxShadows = exports.baseShadow = exports.shadowColor = exports.radius = exports.radii = exports.pill = exports.transition = exports.scaleFactor = exports.fontWeights = exports.bold = exports.regular = exports.fontSizes = exports.mono = exports.font = exports.space = exports.mediaQueries = exports.breakpoints = exports.cx = exports.colors = exports.brand = exports.grays = exports.palette = void 0;

var _palx = _interopRequireDefault(require("palx"));

var _lodash = require("lodash");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var red = '#e42d42';
var blue = '#2d9ce4';
var palette = (0, _palx["default"])(blue);
exports.palette = palette;
var grays = {
  darker: '#121217',
  dark: '#17171d',
  black: palette.black,
  slate: palette.gray[8],
  silver: palette.gray[7],
  smoke: palette.gray[2],
  snow: palette.gray[0],
  white: '#ffffff'
};
exports.grays = grays;
var brand = {
  primary: red,
  accent: palette.indigo[4],
  success: palette.teal[5],
  info: palette.blue[5],
  warning: palette.orange[5],
  error: palette.red[7],
  muted: grays.silver
};
exports.brand = brand;

var colors = _objectSpread({}, brand, {}, grays, {}, palette);

exports.colors = colors;

var cx = function cx(key) {
  return (0, _lodash.get)(colors, key, key);
};

exports.cx = cx;

var createMediaQuery = function createMediaQuery(n) {
  return "@media screen and (min-width:".concat(n, "em)");
};

var addAliases = function addAliases(arr, aliases) {
  return aliases.forEach(function (key, i) {
    return Object.defineProperty(arr, key, {
      enumerable: false,
      get: function get() {
        return this[i];
      }
    });
  });
};

var aliases = ['sm', 'md', 'lg', 'xl'];
var breakpoints = [32, 48, 64, 80];
exports.breakpoints = breakpoints;

var mediaQueries = _objectSpread({}, breakpoints.map(createMediaQuery), {
  reduceMotion: '@media (prefers-reduced-motion: reduce)',
  reduceTransparency: '@media (prefers-reduced-transparency: reduce)'
});

exports.mediaQueries = mediaQueries;
addAliases(breakpoints, aliases);
addAliases(mediaQueries, aliases);
var space = [0, 6, 12, 18, 24, 36, 72, 108, 144, 288, 432];
exports.space = space;
var emoji = '"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"';
var font = "\"Phantom Sans\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,sans-serif,".concat(emoji);
exports.font = font;
var mono = 'SFMono-Regular,"Roboto Mono",Menlo,monospace';
exports.mono = mono;
var fontSizes = [13.5, 16, 18, 24, 27, 36, 48, 54, 72, 96];
exports.fontSizes = fontSizes;
var regular = 'regular';
exports.regular = regular;
var bold = 'bold'; // styled-system's `fontWeight` function can hook into the `fontWeights` object

exports.bold = bold;
var fontWeights = {
  regular: regular,
  bold: bold
};
exports.fontWeights = fontWeights;
var scaleFactor = 17 / 16;
exports.scaleFactor = scaleFactor;
var transition = "".concat(3 / 16, "s cubic-bezier(0.375, 0, 0.675, 1)"); // styled-system’s `borderRadius` function can hook into the `radii` object/array

exports.transition = transition;
var pill = '9999px';
exports.pill = pill;
var radii = ['0px', '4px', '8px', '16px', pill];
exports.radii = radii;
var radius = '4px';
exports.radius = radius;
var shadowColor = 'rgba(0,0,0,0.125)';
exports.shadowColor = shadowColor;
var baseShadow = '0 0 2px 0 rgba(0,0,0,.0625),';
exports.baseShadow = baseShadow;
var boxShadows = [baseShadow + "0 2px 4px 0 ".concat(shadowColor), baseShadow + "0 4px 8px 0 ".concat(shadowColor), baseShadow + "0 12px 12px 0 ".concat(shadowColor), baseShadow + "0 24px 24px 0 ".concat(shadowColor)];
exports.boxShadows = boxShadows;

var hexa = function hexa(color, alpha) {
  var hex = cx(color);
  if (!(0, _lodash.includes)(hex, '#')) return shadowColor;
  var r = parseInt(hex.slice(1, 3), 16),
      g = parseInt(hex.slice(3, 5), 16),
      b = parseInt(hex.slice(5, 7), 16);

  if (alpha >= 0) {
    return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(alpha, ")");
  } else {
    return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
  }
};

exports.hexa = hexa;

var gradient = function gradient(color1, color2) {
  return "radial-gradient(\n    ellipse farthest-corner at top left,\n    ".concat(cx(color1), " 0%, ").concat(cx(color2), " 100%\n  )");
};

exports.gradient = gradient;
var theme = {
  breakpoints: breakpoints,
  mediaQueries: mediaQueries,
  space: space,
  mono: mono,
  font: font,
  fontSizes: fontSizes,
  fontWeights: fontWeights,
  regular: regular,
  bold: bold,
  colors: colors,
  radii: radii,
  radius: radius,
  pill: pill,
  scaleFactor: scaleFactor,
  transition: transition,
  boxShadows: boxShadows,
  shadowColor: shadowColor,
  cx: cx,
  hexa: hexa,
  gradient: gradient
};
var _default = theme;
exports["default"] = _default;